enum ClassificationMethod {
  EQUAL_INTERVAL = "equalInterval",
  NATURAL_BREAKS = "naturalBreaks",
  QUANTILE = "quantile",
  MANUAL = "manual",
}

export default ClassificationMethod;
